import DigestHeader from './DigestHeader';

export default DigestHeader;
